export const generateClientKey = () => {
  let result = "";
  const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  for (var i = 5; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};



// WEBPACK FOOTER //
// ./src/sagas/util/keyGenerators.js